import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Profile from "@/pages/Profile";
import AdminUsers from "@/pages/AdminUsers";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Meetings from "@/pages/Meetings";
import Synergy from "@/pages/Synergy";
import Wingman from "@/pages/Wingman";
import Campaigns from "@/pages/Campaigns";
import Leads from "@/pages/Leads";
import Invoices from "@/pages/Invoices";
import AccountingClients from "@/pages/AccountingClients";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="h-8 w-8 rounded-full border-2 border-[#193962] border-t-transparent animate-spin" />
    </div>
  );
}

function Protected({ children, adminOnly }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/" replace />;
  if (user.role === "Accountant" && !["/invoices", "/accounting/clients"].includes(location.pathname)) return <Navigate to="/invoices" replace />;
  if (adminOnly && user.role !== "Admin") return <Navigate to="/dashboard" replace />;
  return children;
}

function PublicHome() {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (user) return <Navigate to="/dashboard" replace />;
  return <Login />;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<PublicHome />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/clients" element={<Protected><Clients /></Protected>} />
      <Route path="/clients/:id" element={<Protected><ClientDetail /></Protected>} />
      <Route path="/meetings" element={<Protected><Meetings /></Protected>} />
      <Route path="/synergy" element={<Protected><Synergy /></Protected>} />
      <Route path="/wingman" element={<Protected><Wingman /></Protected>} />
      <Route path="/campaigns" element={<Protected><Campaigns /></Protected>} />
      <Route path="/leads" element={<Protected><Leads /></Protected>} />
      <Route path="/invoices" element={<Protected><Invoices /></Protected>} />
      <Route path="/accounting/clients" element={<Protected><AccountingClients /></Protected>} />
      <Route path="/profile" element={<Protected><Profile /></Protected>} />
      <Route path="/admin/users" element={<Protected adminOnly><AdminUsers /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
